import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { SessionVariable, SessionVariablesResult } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class RpaSystemApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/rpa-system`;
  }

  async sendProcessStopRequest(processId: string): Promise<void> {
    return await this.post(`processes/${processId}/request-stop`, null);
  }

  async sendSessionStopRequest(sessionId: string): Promise<void> {
    return await this.post(`sessions/${sessionId}/request-stop`, null);
  }

  async sendCustomSessionStopRequest(sessionId: string): Promise<SessionVariablesResult> {
    return await this.postWithResult<null, SessionVariablesResult>(`sessions/${sessionId}/custom-request-stop`, null);
  }

  async getSessionVariables(sessionId: string): Promise<SessionVariablesResult> {
    return await this.get<SessionVariablesResult>(`sessions/${sessionId}/variables`);
  }

  async setSessionVariables(sessionId: string, variables: SessionVariable[]): Promise<SessionVariablesResult> {
    return await this.postWithResult<{ variables: SessionVariable[] }, SessionVariablesResult>(`sessions/${sessionId}/variables`, { variables });
  }

  async restartResource(resourceId: string): Promise<void> {
    return await this.post(`resources/${resourceId}/restart`, null);
  }

  async turnOnResource(resourceId: string): Promise<void> {
    return await this.post(`resources/${resourceId}/turn-on`, null);
  }

  async turnOffResource(resourceId: string): Promise<void> {
    return await this.post(`resources/${resourceId}/turn-off`, null);
  }
}
